export enum TooltipLabel {
	Name = 'name',
	Iso2 = 'iso2'
}
